import React, { Component } from 'react';

class NumberDisplay extends Component {
  formatNumberWithCommas(amount) {
    if (typeof amount !== 'number' && typeof amount !== 'string') {
      return 0;
    }

    const number = typeof amount === 'string'
      ? parseFloat(amount.replace(/,/g, ''))
      : amount;

    if (isNaN(number)) {
      return 0 ;
    }

    return number.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  render() {
    const formattedValue = this.formatNumberWithCommas(this.props.value);
    return <>{formattedValue}</>;
  }
}

export default NumberDisplay;
